import i18n from '@/i18n/config';

import { RouteException } from './RouteException';

export class RouteNotFoundException extends RouteException {
  constructor() {
    super(
      'not-found',
      i18n.t('Oops... no encontramos la página'),
      i18n.t('Comprueba la url o tu conexión a internet')
    );
  }
}
